import React from "react";
import PropTypes from "prop-types";
import BtnGreen from "../BtnGreen";
import { useDispatch } from "react-redux";
import { toggleModalConfirm, toggleModal } from "@/store/slices/GlobalSlice";

const ExitConfirm = (props) => {
  const dispatch = useDispatch();

  const handleContinue = () => {
    dispatch(toggleModalConfirm());
  };

  const handleCancel = () => {
    dispatch(toggleModalConfirm());
    dispatch(toggleModal());
  };

  return (
    <div className="text-sgbc-black-800 text-center">
      <h2 className="text-28 font-semibold mb-4">Are you sure?</h2>

      <div className="text-lg mb-5">
        Please confirm if you would like to cancel your entry or proceed with
        the submission.
      </div>

      <div className="md:space-x-5 space-y-5 md:space-y-0">
        <BtnGreen className="flex items-center" onClick={handleContinue}>
          <span>Continue Submission</span>
          <span className="ml-5">
            <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
          </span>
        </BtnGreen>

        <BtnGreen className="flex items-center" onClick={handleCancel}>
          <span>Cancel Entry</span>
          <span className="ml-5">
            <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
          </span>
        </BtnGreen>
      </div>
    </div>
  );
};

ExitConfirm.propTypes = {};

export default ExitConfirm;
